<template>
  <div>
    <a-table
      style="min-width: 800px"
      :columns="columns"
      :scroll="{ y: 300 }"
      :rowKey="(text, index) => text.id + index"
      :pagination="tableRelevant.tablePagination"
      :loading="tableRelevant.tableLoading"
      :locale="tableRelevant.locale"
      :dataSource="tableRelevant.tableDataSource"
    >
      <div slot="contentType" slot-scope="text">
        <span v-if="text.contentType === 1" style="color: #1e9fff">测评</span>
        <span v-else-if="text.contentType === 2" style="color: #ff5722">训练</span>
        <span v-else-if="text.contentType === 3" style="color: #2f4056">题目壳</span>
        <span v-else-if="text.contentType === 4" style="color: #dabd43">课程视频</span>
        <span v-else-if="text.contentType === 5" style="color: #dabd43">亲子游戏</span>
        <span v-else>未知类型</span>
      </div>
      <div slot="classifyTag" slot-scope="text">
        <span style="color: green" v-if="text.classifyTag == 1">商用</span>
        <span style="color: #f90" v-else-if="text.classifyTag == 4">科研</span>
        <span v-else>--</span>
      </div>
      <div slot="abilityTypeName" slot-scope="text">
        <div class="self_td" v-for="item in text.contentAbilitys" :key="item.id">
          {{ item.abilityTypeName }}- {{ item.firstAbilityName }}-
          {{ item.secondAbilityName }}
        </div>
      </div>
      <div slot="contentDisplayOrder" slot-scope="text">
        <a-input-number v-model="text.contentDisplayOrder" :min="0" :max="99999" class="table-input" />
      </div>
      <div slot="guideVideo" slot-scope="text">
        <a-switch v-model="text.isLinkVedio" checked-children="启用" un-checked-children="禁用" />
      </div>
      <div slot="scoreSetting" slot-scope="text" class="table-ability">
        <div v-for="(item, index) in text.contentAbilitys" :key="index">
          <a-switch v-model="item.isSetting" checked-children="启用" un-checked-children="禁用" />
        </div>
      </div>
      <div slot="fixedContent" slot-scope="text">
        <a-switch v-model="text.isRegularContent" checked-children="启用" un-checked-children="禁用" />
      </div>
      <div slot="carryNumber" slot-scope="text">
        <a-input-number :disabled="text.contentType !== 2" v-model="text.executionsNumber" :min="1" :max="99999" class="table-input" />
      </div>
    </a-table>
  </div>
</template>

<script>
import { tableRelevant } from '@/pages/projectImpl/js/utils'

const columns = [
  {
    title: '内容排序',
    scopedSlots: { customRender: 'contentDisplayOrder' },
  },
  {
    title: '内容名称',
    dataIndex: 'name',
  },
  {
    title: '版本名称',
    dataIndex: 'versionName',
  },
  {
    title: '内容类型',
    scopedSlots: { customRender: 'contentType' },
  },
  {
    title: '游戏类型',
    scopedSlots: { customRender: 'classifyTag' },
  },
  {
    title: '能力维度',
    class: 'testClass',
    key: 'abilityTypeName',
    width: 300,
    align: 'center',
    scopedSlots: { customRender: 'abilityTypeName' },
  },
  {
    title: '指导视频',
    scopedSlots: { customRender: 'guideVideo' },
  },
  {
    title: '算分设置',
    scopedSlots: { customRender: 'scoreSetting' },
  },
  {
    title: '固定内容',
    scopedSlots: { customRender: 'fixedContent' },
  },
  {
    title: '执行次数',
    scopedSlots: { customRender: 'carryNumber' },
  },
]
export default {
  name: 'thirdStep',
  props: {
    contentData: {
      type: Array,
      value: [],
    },

    type: String,
  },
  data() {
    return {
      columns,
      tableRelevant: tableRelevant.call(this),
    }
  },
  mounted() {
    if (!this.contentData.length) {
      this.tableRelevant.tableDataSource = []
      return
    }
    if (this.type === 'edit') {
      this.columns = [
        {
          title: '内容排序',
          scopedSlots: { customRender: 'contentDisplayOrder' },
        },
        {
          title: '能力维度',
          class: 'testClass',
          key: 'abilityTypeName',
          width: 300,
          align: 'center',
          scopedSlots: { customRender: 'abilityTypeName' },
        },
        {
          title: '指导视频',
          scopedSlots: { customRender: 'guideVideo' },
        },
        {
          title: '算分设置',
          scopedSlots: { customRender: 'scoreSetting' },
        },
        {
          title: '固定内容',
          scopedSlots: { customRender: 'fixedContent' },
        },
        {
          title: '执行次数',
          scopedSlots: { customRender: 'carryNumber' },
        },
      ]
    }
    // JSON.parse(JSON.stringify(this.contentData))[0].isLinkVedio = false
    this.tableRelevant.tableDataSource = JSON.parse(JSON.stringify(this.contentData))
    // this.tableRelevant.tableDataSource[0].isLinkVedio = false
  },
}
</script>

<style scoped lang="less">
.table-input /deep/ .ant-input-number-handler-wrap {
  display: none;
}

.table-input {
  width: 100%;
  border: none;
  background: none;
  outline: none;
  box-shadow: none;
}

.table-input:focus {
  border: none;
  background: none;
  outline: none;
  box-shadow: none;
}

.table-ability div:not(:last-child) {
  padding-bottom: 32px;
}
</style>
